import ProductCategoryModal from './ProductCategoryModal';

export default ProductCategoryModal;
